import { MdSearch, MdVisibility } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { SelectPicker, Tooltip, Whisper } from 'rsuite';
import styles from './SearchBar.module.scss';

const ATIVO_OPTIONS = [
  { label: 'Somente monitoramentos ativos', value: 'true' },
  { label: 'Somente monitoramentos inativos', value: 'false' },
];

type SearchBarProps = {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  placeholder?: string;
  ativoFilter?: boolean;
  onAtivoFilterChange?: (value: boolean | undefined) => void;
};

const ativoFilterIcon = (
  <span className={styles.ativoFilterValue}>
    <MdVisibility size={20} />
  </span>
);

export const SearchBar = ({
  searchValue = '',
  onSearchChange,
  placeholder = 'Pesquise por um monitoramento',
  ativoFilter,
  onAtivoFilterChange,
}: SearchBarProps) => {
  const history = useHistory();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange?.(e.target.value);
  };

  const handleAtivoFilterChange = (value: string | null) => {
    if (value === null) {
      onAtivoFilterChange?.(undefined);
      return;
    }
    onAtivoFilterChange?.(value === 'false' ? false : true);
  };

  const handleCreateClick = () => {
    history.push('/isa/central-de-monitoramento/criar');
  };

  const ativoFilterValue = ativoFilter === undefined ? null : String(ativoFilter);
  const ativoFilterLabel =
    ativoFilter === undefined
      ? 'Todos os monitoramentos'
      : ativoFilter
      ? 'Somente monitoramentos ativos'
      : 'Somente monitoramentos inativos';

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.searchWrapper}>
          <div className={styles.searchInput}>
            <div className={styles.iconWrapper}>
              <MdSearch size={18} className={styles.searchIcon} />
            </div>
            <input
              type="text"
              className={styles.input}
              placeholder={placeholder}
              value={searchValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className={styles.actionWrapper}>
          <Whisper trigger="hover" placement="bottom" speaker={<Tooltip>Filtrar monitoramentos ativos e inativos</Tooltip>}>
            <SelectPicker
              className={styles.ativoFilter}
              data={ATIVO_OPTIONS}
              value={ativoFilterValue}
              searchable={false}
              cleanable={false}
              placeholder={ativoFilterIcon as unknown as string}
              onChange={handleAtivoFilterChange}
              aria-label={ativoFilterLabel}
              renderValue={() => ativoFilterIcon}
            />
          </Whisper>
          <button type="button" className={styles.createButton} onClick={handleCreateClick}>
            CRIAR NOVO MONITORAMENTO
          </button>
        </div>
      </div>
    </div>
  );
};

